import { render, staticRenderFns } from "./LoginCore.vue?vue&type=template&id=ddd1769c&scoped=true"
import script from "./LoginCore.vue?vue&type=script&lang=js"
export * from "./LoginCore.vue?vue&type=script&lang=js"
import style0 from "./LoginCore.vue?vue&type=style&index=0&id=ddd1769c&prod&lang=less"
import style1 from "./LoginCore.vue?vue&type=style&index=1&id=ddd1769c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd1769c",
  null
  
)

export default component.exports